import { format, parseISO } from 'date-fns';

export default function addMaskDate(date: string) {
  const dateParsed = parseISO(date);

  return format(dateParsed, 'dd/MM/yyyy');
}